// Dados de recomendações — edite este array para adicionar/remover itens
// aspectRatio: "3/4" para jogos/anime/filmes/mangás, "1/1" para álbuns de música

export const recommendations = [
  {
    id: 'video-games',
    category: 'Video Games',
    items: [
      {
        name: 'Super Mario Bros',
        image: 'https://www.notebookcheck.info/fileadmin/Notebooks/News/_nc3/supermariobros.png   ',
        comment: 'Bons fundamentos nunca morrem, é impressionante oque dá pra fazer só com pulo e corrida. Santo Graal dos videogames.',
        aspectRatio: '3/4',
      },
      {
        name: 'Pokémon Ruby',
        image: 'https://m.media-amazon.com/images/M/MV5BMjkzYmZhZmUtNTI1NS00NGNkLTg3OTMtYjJjNGFhYzA4NDlmXkEyXkFqcGc@._V1_.jpg',
        comment: 'Meu primeiro pokemon, um dos pontos altos da franquia e envelheceu muito bem (diferente dos seus antecessores), Blaziken é o melhor inicial, ponto.',
        aspectRatio: '3/4',
      },
      {
        name: 'Phoenix Wright: Ace Attorney',
        image: 'https://m.media-amazon.com/images/M/MV5BYzM3NjY4YmItMGM2Mi00ODljLTk0YmItYTJiN2VhMzFjOGI2XkEyXkFqcGc@._V1_.jpg',
        comment: 'Boa parte do que sei de inglês eu aprendi jogando Ace Attorney, extremamente criativo e bem amarrado, como eles conseguiram fazer um jogo de advogado ser divertido?!',
        aspectRatio: '3/4',
      },
      {
        name: 'Inazuma Eleven 2: Firestorm',
        image: 'https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co407m.jpg',
        comment: 'Anime, futebol, JRPG e ALIENS. Tem como ficar melhor?',
        aspectRatio: '3/4',
      },
      {
        name: 'Metal Gear Solid V: The Phantom Pain',
        image: 'https://upload.wikimedia.org/wikipedia/pt/1/19/MGS5_TPP.jpg',
        comment: 'The sins never dies.',
        aspectRatio: '3/4',
      },
      {
        name: 'Dragon Quest XI S: Echoes of an Elusive Age',
        image: 'https://image.api.playstation.com/vulcan/ap/rnd/202007/1607/7PxHVp3tCaQQkVeHalUtPcND.png',
        comment: 'Uma celebração do JRPG, mantendo a formula clássica sem perder o novo de vista. Minha recomendação pra quem quer começar Dragon Quest.',
        aspectRatio: '3/4',
      },
      {
        name: 'Resident Evil 4',
        image: 'https://sm.ign.com/ign_br/cover/r/resident-e/resident-evil-4_4tut.jpg',
        comment: 'Welcome stranger! Heheheh thank you. What are you buying? What are you selling? Heheheh.',
        aspectRatio: '3/4',
      },
      {
        name: 'Pro Evolution Soccer 2018',
        image: 'https://store-images.s-microsoft.com/image/apps.63865.64357578580207892.a3204267-07ae-4ccf-aa36-834b2b495b29.0e0c3677-e6e5-4925-be0a-a098279777b9',
        comment: 'Talvez o auge da franquia PES, jogabilidade fluida e divertida. Perdi as contas de quantas temporadas de master league eu joguei, pra fechar a conta a playlist é absurda.',
        aspectRatio: '3/4',
      },
      {
        name: 'Persona 5',
        image: 'https://upload.wikimedia.org/wikipedia/pt/5/52/Persona_5_capa.jpg',
        comment: 'Estilo acima de substância? Talvez, mas que estilo.',
        aspectRatio: '3/4',
      },
      {
        name: 'Persona 3 Reload',
        image: 'https://www.nintendo.com/eu/media/images/assets/nintendo_switch_2_games/persona3reload/1x1_Persona3Reload_image500w.jpg',
        comment: 'Estilo, substância e encontros com garotas, persona core.',
        aspectRatio: '3/4',
      },
      {
        name: 'Starbound',
        image: 'https://store-images.s-microsoft.com/image/apps.5801.14160576273832138.6151b080-046e-4712-881b-764f3d2708e2.bc6e2ab0-0925-4919-abf8-bbd3ecde2f24',
        comment: 'Tenho um carinho especial com Starbound, tem seus problemas, mas ele tem um charme que eu não sei explicar, poderia passar mais de 100 horas jogando, alguém pra jogar comigo?',
        aspectRatio: '3/4',
      },
      {
        name: 'Grand Theft Auto IV',
        image: 'https://upload.wikimedia.org/wikipedia/en/thumb/b/b7/Grand_Theft_Auto_IV_cover.jpg/250px-Grand_Theft_Auto_IV_cover.jpg',
        comment: 'A decadência de Liberty City nunca foi tão bela.',
        aspectRatio: '3/4',
      },
      {
        name: 'Dragon Ball Z Budokai 3',
        image: 'https://m.media-amazon.com/images/M/MV5BMTJlYTUyZDItM2MxZS00MTQxLWFhMDgtMGIyN2NlYmE0NmE0XkEyXkFqcGc@._V1_FMjpg_UX1000_.jpg',
        comment: 'O pacote completo DBZ: modo história, muitos personagens, combate divertido e abertura foda. Melhor que o Tenkaichi 3 btw.',
        aspectRatio: '3/4',
      },
      {
        name: 'Yu-Gi-Oh! GX Tag Force',
        image: 'https://static.wikia.nocookie.net/yugioh/images/3/3b/GX05-VideoGameEN.png/revision/latest?cb=20080629233418',
        comment: 'Ideia genial de colocar o seu personagem na academia de duelo, pra duelar e interagir com seus personagens favoritos, e ainda no auge do formato GOAT.',
        aspectRatio: '3/4',
      },
      {
        name: 'The Legend of Zelda: Minish Cap',
        image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS6tnvGdfddf_MRk4e7NlCYA8DwscT_ZHcl0Q&s',
        comment: 'Meu primeiro Zelda, não se destaca tanto quanto outros, mas ainda tem ideias criativas, além da arte e pixel art serem lindas, ouso dizer as mais bonitas da franquia.',
        aspectRatio: '3/4',
      },
      {
        name: 'Watch Dogs',
        image: 'https://upload.wikimedia.org/wikipedia/pt/1/1b/Watch_dogs_cover.jpg',
        comment: 'Jogo subestimado, a história é solida, o mundo aberto é amplo e detalhado (apesar de meio sem sal), a parte de hacking é o diferencial que funciona muito bem.',
        aspectRatio: '3/4',
      },
      {
        name: 'Assassins Creed II',
        image: 'https://upload.wikimedia.org/wikipedia/pt/a/ac/Assassins_Creed_2_capa.png',
        comment: 'Início da formula ubisoft que conhecemos? Talvez, mas ainda fresca, amarrando todos os elementos de forma elegante (combate, stealth, exploração e história).',
        aspectRatio: '3/4',
      }
    ],
  },
  {
    id: 'anime',
    category: 'Anime',
    items: [
      {
        name: 'Death Note',
        image: 'https://m.media-amazon.com/images/M/MV5BYTgyZDhmMTEtZDFhNi00MTc4LTg3NjUtYWJlNGE5Mzk2NzMxXkEyXkFqcGc@._V1_.jpg',
        comment: 'Anime obrigatório pra qualquer um, fã de anime ou não. Premissa única, personagens icônicos e o mais importante, faz comer uma batata frita parecer foda pra caralho.',
        aspectRatio: '3/4',
      },
      {
        name: 'Kaiji: Ultimate Survivor',
        image: 'https://upload.wikimedia.org/wikipedia/en/8/8a/Kaiji_Ultimate_Survivor_DVD_BOX.png',
        comment: 'Zawa zawa zawa zawa zawa...',
        aspectRatio: '3/4',
      },
      {
        name: 'Phi Brain: Kami no Puzzle',
        image: 'https://m.media-amazon.com/images/S/pv-target-images/3f009049f494781cfd646ef72d3a7f6d8efeca32360d25b8c8345e83089c5289.jpg',
        comment: 'Eu resolvendo quebra quebeças usando um bracelete que usa 100% do cérebro, não precisa de muito mais pra recomendar.',
        aspectRatio: '3/4',
      },
      {
        name: 'Neon Genesis Evangelion',
        image: 'https://br.web.img3.acsta.net/c_310_420/pictures/18/12/07/12/40/4530128.jpg',
        comment: 'Parabains, boa Shinji, muitos parabains.',
        aspectRatio: '3/4',
      },
      {
        name: 'Jujutsu Kaisen',
        image: 'https://ovicio.com.br/wp-content/uploads/2025/11/20251107-poster-oficial-da-temporada-3-de-jujutsu-kaisen-ovicio-722x1024.webp',
        comment: 'Você vai entender a graça de jujutsu kaisen quando ver o narrador explicando uma técnica muito especifica que só vai ser usada nessa batalha.',
        aspectRatio: '3/4',
      },
      {
        name: 'Parasyte',
        image: 'https://m.media-amazon.com/images/M/MV5BMzg2YjA0NGYtYjQwMS00MDQyLWFlNWMtODVhNTBkYWIyNjE1XkEyXkFqcGc@._V1_.jpg',
        comment: 'Uma reflexão sobre o valor da vida, da natureza e da humanidade embalado como um battle shounen.',
        aspectRatio: '3/4',
      },
      {
        name: 'Saiki Kusuo no Psi-nan',
        image: 'https://m.media-amazon.com/images/M/MV5BMzJhYWEyMWUtZDYwNS00NTU4LTgwODItYjBlNzEwMTc5MTc2XkEyXkFqcGc@._V1_FMjpg_UX1000_.jpg',
        comment: 'Comédia escolar goofy e o protagonista tem poderes psiquicos, yare yare.',
        aspectRatio: '3/4',
      },
      {
        name: 'Shingeki no Kyojin',
        image: 'https://static.wikia.nocookie.net/shingekinokyojin/images/d/d8/Attack_on_Titan_Season_1.jpg/revision/latest/scale-to-width-down/1200?cb=20211005182832',
        comment: 'Anime de mecha sem robô, com zumbis que não são zumbis, e um shounen que não é shounen.',
        aspectRatio: '3/4',
      },
      {
        name: 'Dragon Ball Z',
        image: 'https://m.media-amazon.com/images/M/MV5BNmFiM2FkYTYtY2FiOS00ZWJkLTkyOTgtNmFmODI4NjcwNDgzXkEyXkFqcGc@._V1_.jpg',
        comment: 'O pai do battle shounen moderno.',
        aspectRatio: '3/4',
      },
      {
        name: 'Angel Beats',
        image: 'https://upload.wikimedia.org/wikipedia/pt/c/c6/Angel_Beats_poster.jpg',
        comment: 'Você chorou no final?',
        aspectRatio: '3/4',
      },
      {
        name: 'Eyeshield 21',
        image: 'https://m.media-amazon.com/images/M/MV5BYTI4MzQ0MDItZWE2Yi00YWU3LThjNTEtNGU0YjEyYzE3YjVlXkEyXkFqcGc@._V1_FMjpg_UX1000_.jpg',
        comment: 'Sprite de morango em forma de anime de esporte, não vou elaborar.',
        aspectRatio: '3/4',
      },
    ],
  },
  {
    id: 'filmes',
    category: 'Filmes',
    items: [
      {
        name: 'Matrix',
        image: 'https://thumbs.web.sapo.io/?W=419&pic=https://mb.web.sapo.io/67edfbe216c770d5f4b6341ac9825ba823d66416.jpg&delay_optim=1&webp=1&Q=80&tv=1',
        comment: 'Não existe colher.',
        aspectRatio: '3/4',
      },
      {
        name: 'Tropa de Elite',
        image: 'https://images.justwatch.com/poster/303450506/s718/tropa-de-elite.jpg',
        comment: 'Tem carburador ou não tem carburador?',
        aspectRatio: '3/4',
      },
      {
        name: 'Police Story',
        image: 'https://upload.wikimedia.org/wikipedia/en/a/a3/Police-Story-poster.jpg',
        comment: 'Auge do Jackie Chan, se você curte filmes de ação você tem o DEVER de assistir esse filme o mais rápido possível.',
        aspectRatio: '3/4',
      },
      {
        name: 'Force Majeure',
        image: 'https://m.media-amazon.com/images/S/pv-target-images/3e50c7442ad041dafff73ee7d3b79797faf649d681e22f127a4f0cd0b8b7264b.jpg',
        comment: 'Veja minha review.',
        aspectRatio: '3/4',
      },
      {
        name: ' Agente Secreto',
        image: 'https://m.media-amazon.com/images/I/8148hJZ+9jL._AC_UF1000,1000_QL80_.jpg',
        comment: 'Um filme sobre um Recife com muita pirraça',
        aspectRatio: '3/4',
      },
      {
        name: 'O Show de Truman',
        image: 'https://s3.amazonaws.com/nightjarprod/content/uploads/sites/192/2023/08/15115111/vuza0WqY239yBXOadKlGwJsZJFE.jpg',
        comment: 'In case I don\'t see ya, good afternoon, good evening, and good night!',
        aspectRatio: '3/4',
      },
      {
        name: 'Akira',
        image: 'https://br.web.img3.acsta.net/medias/nmedia/18/87/36/26/19874715.jpg',
        comment: 'KANEDAAAAA! TETSUOOOO!',
        aspectRatio: '3/4',
      },
      {
        name: 'Sem Limites',
        image: 'https://preview.redd.it/sem-limites-2011-segundo-alguns-lucy-%C3%A9-um-filme-meia-boca-v0-6tdzed2xrdpd1.jpeg?auto=webp&s=4f777f27d4453f695b8392ef93d0198228ada27e',
        comment: 'Power fantasy de inteligência, retrata muito bem oque seria estar em um estado de fluxo constante. Bradley Cooper carismático como sempre no papel.',
        aspectRatio: '3/4',
      },
      {
        name: 'Onze Homens e um Segredo',
        image: 'https://br.web.img3.acsta.net/medias/nmedia/18/91/08/70/20128740.jpg',
        comment: 'Um filme sobre o espírito humano de cooperação, a trilha sonora encaixa como uma luva com os ambientes de casinos em Las Vegas, incrivel como esse filme é gostoso de assistir.',
        aspectRatio: '3/4',
      },
      {
        name: 'Gigantes de Aço',
        image: 'https://upload.wikimedia.org/wikipedia/pt/thumb/5/52/Real_Steel_P%C3%B4ster.jpg/250px-Real_Steel_P%C3%B4ster.jpg',
        comment: 'Um remake de Rocky, só que com robôs lutando boxe, aura.',
        aspectRatio: '3/4',
      },
      {
        name: 'Taxi Driver',
        image: 'https://m.media-amazon.com/images/M/MV5BZDNhMGYwM2UtMTdlZS00MGQ1LWI2YzAtODY5YWI1MjYyNzRmXkEyXkFqcGc@._V1_.jpg',
        comment: 'A decadência de um homem solitário e da cidade de Nova York, um clássico dos clássicos, divisor de águas do cinema moderno.',
        aspectRatio: '3/4',
      },
      {
        name: 'Battle Royale',
        image: 'https://img.vwassets.com/orpheum.com.au/1721709305067_BattleRoyale.jpg',
        comment: 'Fundador do gênero Battle Royale, violento, visceral e até engraçado (ou só eu que sou doente mesmo).',
        aspectRatio: '3/4',
      },
    ],
  },
  {
    id: 'musicas',
    category: 'Músicas',
    items: [
      {
        name: 'Da Lama ao Caos - Chico Science & Nação Zumbi',
        image: 'https://s2-g1.glbimg.com/fxOYKpxuNqjjE0CEnk2yI-WLTso=/0x0:1500x1500/924x0/smart/filters:strip_icc()/i.s3.glbimg.com/v1/AUTH_59edd422c0c84a879bd37670ae4f538a/internal_photos/bs/2019/n/y/nZPuQgSJCBxBdUh9LAAQ/discodalamaaocaos.jpg',
        comment: 'Um homem roubado nunca se engana.',
        aspectRatio: '1/1',
      },
      {
        name: 'Chop Suey! - System of a Down',
        image: 'https://m.media-amazon.com/images/I/81O5BH0QI4L._UF1000,1000_QL80_.jpg',
        comment: 'We are rolling suicide...',
        aspectRatio: '1/1',
      },
      {
        name: 'Indestructible - Disturbed',
        image: 'https://upload.wikimedia.org/wikipedia/en/6/61/Indestructible_%28Disturbed_album%29_cover.jpg',
        comment: 'Take a last look while you\'re alive I\'m an indestructible master of war.',
        aspectRatio: '1/1',
      },
      {
        name: 'Somewhere I Belong - Linkin Park',
        image: 'https://i.scdn.co/image/ab67616d0000b2733bf522c6dc62594670b316e6',
        comment: 'Hell yeah core CARALHO!',
        aspectRatio: '1/1',
      },
      {
        name: 'Coming Undone - Korn',
        image: 'https://i.scdn.co/image/ab67616d0000b27374c1560b64750a1774495144',
        comment: 'I\'m trying to hold it together, head is lighter than a feather, looks like I\'m not getting better, not getting better.',
        aspectRatio: '1/1',
      },
      {
        name: 'Headlock - Imogen Heap',
        image: 'https://i.scdn.co/image/ab67616d0000b273866872ba52cf201fc33995cc',
        comment: 'You know you\'re better than this. ',
        aspectRatio: '1/1',
      },
      {
        name: 'Diário de um Detento - Racionais MC\'s',
        image: 'https://images.genius.com/d8b38b702eefc1ec588908bd5037fa9b.999x999x1.png',
        comment: 'Aqui estou mais um dia, sob o olhar sanguinário do vigia.',
        aspectRatio: '1/1',
      },
      {
        name: 'Primo Victoria - Sabaton',
        image: 'https://e.snmc.io/i/1200/s/1d47987fae4d825424a988b618a07fd1/2760504',
        comment: 'Through the gates of hell, as we make our way to heaven.',
        aspectRatio: '1/1',
      },
      {
        name: 'Jesus Walks - Kanye West',
        image: 'https://i.scdn.co/image/ab67616d0000b27325b055377757b3cdd6f26b78',
        comment: 'God show me the way because the devil\'s been tryna break me down.',
        aspectRatio: '1/1',
      },
      {
        name: 'Let Me Hear - Fear, and Loathing in Las Vegas',
        image: 'https://i.scdn.co/image/ab67616d0000b273cedfdc1f2a9ca7c2b5bda543',
        comment: 'At the point that we\'re born we are winners of earth.',
        aspectRatio: '1/1',
      },
      {
        name: 'A Feira - O Rappa',
        image: 'https://akamai.sscdn.co/uploadfile/letras/albuns/7/4/5/0/131471774450351.jpg',
        comment: 'É dia de feira, quarta-feira, sexta-feira, não importa a feira...',
        aspectRatio: '1/1',
      },
      {
        name: 'Straight Outta Compton - N.W.A',
        image: 'https://api.audioxide.com/images/album-artwork/straight-outta-compton-nwa-small-square.jpg',
        comment: 'You are now about to witness the strength of street knowledge.',
        aspectRatio: '1/1',
      },
    ],
  },
  {
    id: 'mangas-hqs',
    category: 'Mangás / HQs',
    items: [
      {
        name: 'Blue Lock',
        image: 'https://upload.wikimedia.org/wikipedia/pt/1/1c/Blue_Lock_-_capa_do_volume_1.jpg',
        comment: 'Futebol + Death Game + Egoísmo = Obra Prima.',
        aspectRatio: '3/4',
      },
      {
        name: 'Goodnight Punpun',
        image: 'https://m.media-amazon.com/images/I/51EQ5jMPsHL._AC_UF1000,1000_QL80_.jpg',
        comment: 'Quão fundo alguém pode chegar antes de acordar?',
        aspectRatio: '3/4',
      },
      {
        name: '20th Century Boys',
        image: 'https://m.media-amazon.com/images/I/81TZrYTkAkL._AC_UF1000,1000_QL80_.jpg',
        comment: 'É você que vai doar AMIGO?',
        aspectRatio: '3/4',
      },
      {
        name: 'Onani Master Kurosawa',
        image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgMdCRxjobeQuutYhLsC0n8xjymPlTed8zUVj7lJ8NWnD1RaRPQZioYSA6z7XgT6Ynmmnzh60_wgs5nOSkt9d2bdsAAVcpna__Br8GQttKHywerahok1ObdZ_w3YFWIDFS1cZMm5UiWkqE7/s1600/titulo.jpg',
        comment: 'Ignore a sinopse e leia, um mangá que fala sobre juventude, ressentimento, relacionamentos e principalmente amadurecimento.',
        aspectRatio: '3/4',
      },
      {
        name: 'Gantz',
        image: 'https://m.media-amazon.com/images/I/71ymEyveePL._AC_UF894,1000_QL80_.jpg',
        comment: 'Brutal, violento e instigante, o Oku pode passar do ponto em alguns momentos, mas é esse exagero que me cativou em Gantz.',
        aspectRatio: '3/4',
      },
      {
        name: 'Homunculus',
        image: 'https://m.media-amazon.com/images/I/81VkApOiIdL._AC_UF1000,1000_QL80_.jpg',
        comment: 'Oque significa ser humano? onde eu termino e você começa? Porque é tão difícil se conectar com as pessoas? Homumculus não responde nenhuma dessas perguntas.',
        aspectRatio: '3/4',
      },
      {
        name: 'The Boys',
        image: 'https://quadrinhopole.com/wp-content/uploads/2021/01/theboys_01.jpg?w=400',
        comment: 'Super herois expostos e humilhados, foda-se que é edgy e exagerado, de vez em quando a caricatura é a melhor forma de criticar algo, além disso eu me diverti muito lendo.',
        aspectRatio: '3/4',
      },
      {
        name: 'Invincible',
        image: 'https://d14d9vp3wdof84.cloudfront.net/image/589816272436/image_jcq8plfhjp6ife9fp2gnbcvk4a/-S897-FWEBP',
        comment: 'Um ar refrescante para as HQ\'s de super heróis, um universo muito bem construido com personagens carismaticos que você acompanha a jornada, mostra porque histórias em quadrinhos tem que ter começo meio e fim.',
        aspectRatio: '3/4',
      },
      {
        name: 'Kamisama no Iutoori Ni',
        image: 'https://cdn.myanimelist.net/s/common/store/cover/735/9bf29f80989bd7744b71570bdc50d65219607c444ca0e01593855d4660e3c0d6/l.jpg',
        comment: 'Prequel espiritual de Blue Lock, os jogos são ludicos, tensos e fazem a obra valer a pena, não ironicamente copiado por round 6.',
        aspectRatio: '3/4',
      },
      {
        name: 'Hikaru no Go',
        image: 'https://m.media-amazon.com/images/I/71hZSRUMOcL._AC_UF1000,1000_QL80_.jpg',
        comment: 'Mangá que me ensinou a jogar Go, a arte e o design do Obata estão estonteantes, acompanhar o crescimento do Hikaru, tanto no Go como quanto pessoa é satisfatório.',
        aspectRatio: '3/4',
      },
      {
        name: 'Bakuman',
        image: 'https://m.media-amazon.com/images/I/91+XBco+adL._AC_UF1000,1000_QL80_.jpg',
        comment: 'Só Ohba e Obata poderiam fazer um mangá de esporte sobre mangás ser tão instigante. Gostei de saber como funciona a produção de mangás na Shonen Jump, a parte do romance é fraca mas o resto vale a pena.',
        aspectRatio: '3/4',
      },
      {
        name: 'Death Note',
        image: 'https://m.media-amazon.com/images/I/81iDNjn-r3L.jpg',
        comment: 'Eu sei que já tá na lista de animes, mas o mangá expande em alguns tópicos que o anime sacrifica pelo ritmo, principalmente a parte do Near e Mello, além disso a arte do Obata está no auge.',
        aspectRatio: '3/4',
      },
      {
        name: 'Naruto',
        image: 'https://m.media-amazon.com/images/I/91RpwagB7uL._AC_UF1000,1000_QL80_.jpg',
        comment: 'Fiquei muito em dúvida se colocava na lista de animes ou mangás, mas o mangá é relativamente superior, sem fillers e o ritmo muito melhor.',
        aspectRatio: '3/4',
      },
    ],
  },
];
